import { useMemo } from "react";
import { useApp } from "../../../../services/app-context";
import submittingCertificationGif from "../../../../assets/submitting_certification.gif";
import { getLabel } from "../../utils/labels";

export function CertificationSubmitLoading() {
  const { certificationAssets } = useApp();
  const labels = certificationAssets?.labels ?? {};
  // Get a random fun fact
  const funFact = useMemo(() => {
    const funFacts = certificationAssets?.funFacts || [];
    if (funFacts.length === 0) {
      return `Some say ${getLabel("certification.plural", labels).toLowerCase()} build character. Others say they build caffeine consumption. Both are true.`;
    }
    return funFacts[Math.floor(Math.random() * funFacts.length)];
  }, [certificationAssets]);

  return (
    <div className="fixed inset-0 bg-background flex flex-col items-center justify-center gap-8 px-4">
      <h1 className="text-large-title text-text-primary font-pp-bold text-center">
        Submitting {getLabel("certification.singular", labels)}...
      </h1>

      {/* Illustration */}
      <div className="w-[400px] h-[400px] flex items-center justify-center">
        <img 
          src={submittingCertificationGif} 
          alt="Submitting certification" 
          className="w-full h-full object-contain"
        />
      </div>

      {/* Fun fact text */}
      <div className="max-w-[600px] text-center">
        <p className="text-title2 font-pp-light text-text2 leading-relaxed">
          {funFact}
        </p>
      </div>
    </div>
  );
}
